import { MODAL_SHOW, MODAL_HIDE, MODAL_RESET } from './actions';

const initialState = {
	modalShown: false,
	modalType: null,
	modalProps: {}
};

export default (state = initialState, action) => {

	switch (action.type) {

		case MODAL_SHOW:
			return {
				...state,
				modalShown: true,
				modalType: action.modalType,
				modalProps: {
					...state.modalProps,
					...action.modalProps
				}
			};

		case MODAL_HIDE:
			return {
				...state,
				modalShown: false
			};

		case MODAL_RESET:
			return {
				...state,
				modalType: null,
				modalProps: {}
			};

		default:
			return state;
	}

};

export const showModal = (modalType, modalProps) => {
	return dispatch => {
		dispatch({
			type: MODAL_SHOW,
			modalType,
			modalProps
		});
	};
};

export const hideModal = () => {
	return {
		type: MODAL_HIDE
	};
};


export const resetModal = () => {
	return {
		type: MODAL_RESET
	};
};



// WEBPACK FOOTER //
// ./src/redux/modules/modal.js